import account from "assets/images/account.svg";
import insuranceCard from "assets/images/insurance-card.svg";
import pharmacy from "assets/images/pharmacy.svg";
import taxReport from "assets/images/tax-report.svg";
import transferIn from "assets/images/transfer-in.svg";
import {profile as strings} from "strings";

import CardLink from "components/CardLink";
import PageTitle from "components/PageTitle";

import {useAuthenticatedUser} from "lib/auth";

import styles from "./ProfilePage.module.css";

export default function ProfilePage() {
  const [authenticatedUser] = useAuthenticatedUser();

  return (
    <div className={styles.container}>
      <PageTitle>{authenticatedUser?.data.name || strings.title}</PageTitle>
      <div className={styles.cardLinksContainer}>
        <div className={styles.cardLinks}>
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.pharmacy}
            cardImageLink={pharmacy}
            to="/profile/pharmacy"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.insurance}
            cardImageLink={insuranceCard}
            to="/profile/insurance"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.tax}
            cardImageLink={taxReport}
            to="/profile/tax-report"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.transfer}
            cardImageLink={transferIn}
            to="/profile/transfer-in"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.account}
            cardImageLink={account}
            to="/profile/account"
          />
        </div>
      </div>
    </div>
  );
}
